import { AdsInfoProps, CampaignChannels } from '@/interfaces';

interface UpdateAdProps {
	adsInfoCurrent: AdsInfoProps[];
	adsInfoNew: AdsInfoProps;
	typeChannel: CampaignChannels;
}

export const updateAd = ({
	adsInfoCurrent,
	adsInfoNew,
	typeChannel,
}: UpdateAdProps): AdsInfoProps[] => {
	const aux = [...adsInfoCurrent];
	const index = adsInfoCurrent.findIndex(
		(item) => item.type.toLowerCase() === typeChannel?.toLowerCase()
	);

	if (index !== -1) {
		aux[index] = {
			...aux[index],
			...adsInfoNew,
		};
	}

	return aux;
};

export const getTabInfo = (
	adsInfo: AdsInfoProps[],
	tab: CampaignChannels
): AdsInfoProps | undefined =>
	adsInfo.find((item) => item.type.toLowerCase() === tab?.toLowerCase());
